/**
 * @module
 * @description
 * Entry point for all public APIs of the angular-spinners package.
 */
export * from './src/index';